import ToastHighLighter from '@/lib/ToastHighLighter';

export const FormSizesCode = () => {
  const language = 'html';
  const codeString = `
  // Form sizes
  <div class="form-group mb-3">
    <label class="form-label" htmlFor="floatingInput2">
      Extra large
    </label>
    <input
      class="form-control form-control-lg"
      type="text"
      placeholder=".form-control-lg"
      aria-label=".form-control-lg example"
    />
  </div>
  <div class="mb-3">
    <label class="form-label" htmlFor="floatingInput2">
      Standard
    </label>
    <input
      class="form-control"
      type="text"
      placeholder="Default input"
      aria-label="default input example"
    />
  </div>
  <div class="mb-3">
    <label class="form-label" htmlFor="floatingInput2">
      Small
    </label>
    <input
      class="form-control form-control-sm"
      type="text"
      placeholder=".form-control-sm"
      aria-label=".form-control-sm example"
    />
  </div>
`;

  return (
    <>
      <ToastHighLighter
        name={'formsizes'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
